export const notImage = (nodeAfter) => {
  if (nodeAfter?.type?.name === "image") {
    return false;
  }
  return true;
};
export const handleClickOutside = () => {
  document.querySelectorAll("[data-tippy-root]").forEach((el) => {
    el.remove();
  });
};
